module.exports = __webpack_public_path__ + "8d96720d38eb643e8f0121a7da71ba01.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/sample/rectangle.svg
// module id = 647
// module chunks = 0